'use strict';

module.exports = function flatMap(fn) {
  return this.map(fn).collapse();
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/flatMap.js
// module id = 1659
// module chunks = 2